import Vue from 'vue'
import VueRouter from 'vue-router'
import Generate from '../pages/Generate.vue'
import Schedules from '../pages/Schedules.vue'
import Shared from '../pages/Shared.vue'
import Device from '../pages/Device.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [{
      path: '/',
      name: 'Generate Report',
      component: Generate
    },
    {
      path: '/schedules',
      name: 'Report Schedules',
      component: Schedules
    },
    {
      path: '/shared',
      name: 'Shared Reports',
      component: Shared
    },
    {
      path: '/device',
      name: 'Device Search',
      component: Device
    }
  ]
})

export default router
